// extracted by mini-css-extract-plugin
module.exports = {"button":"InputBtn_button__yiBKO","disabled":"InputBtn_disabled__Y4C9Q","loading":"InputBtn_loading__VvU_j","children":"InputBtn_children__7kDVt"};